module.exports = __webpack_public_path__ + "static/images/alert-triangle.79c42e57442be88b8afa0a2c1177961a.svg";